module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "intended-user-edit-dialog",
    attrs: {
      "close-on-click-modal": false,
      "title": ""
    },
    on: {
      "close": function($event) {
        _vm.closeCallBack()
      }
    },
    model: {
      value: (_vm.visiable),
      callback: function($$v) {
        _vm.visiable = $$v
      },
      expression: "visiable"
    }
  }, [_c('div', {
    attrs: {
      "id": "editform"
    }
  }, [_c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "value": _vm.baseInfo,
      "isReadOnly": _vm.isReadOnly
    },
    on: {
      "showSelectStaffDialog": _vm.showSelectStaffDialog
    }
  }), _vm._v(" "), _c('contact-form', {
    ref: "contact",
    attrs: {
      "value": _vm.contact,
      "isReadOnly": _vm.isReadOnly
    }
  }), _vm._v(" "), _c('business-form', {
    ref: "business",
    attrs: {
      "value": _vm.business,
      "isReadOnly": _vm.isReadOnly
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)]), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16df82d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/edit-dialog/index.vue
// module id = 1396
// module chunks = 1